module.exports = __webpack_public_path__ + "img/breadcrumb-note.5c72ed59.svg";